import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: {
      animation: true,
    },
  },
  {
    path: "/shop_info",
    name: "shop_info_page",
    component: () => import("../views/ShopInfoView.vue"),
    meta: {
      animation: true,
    },
  },
  {
    path: "/news",
    name: "news_list",
    component: () => import("../views/NewsListView.vue"),
    meta: {
      animation: true,
    },
  },
  {
    path: "/news/:id",
    name: "news_page",
    component: () => import("../views/NewsPageView.vue"),
    meta: {
      animation: true,
    },
  },
  {
    path: "/collections",
    name: "product_list",
    component: () => import("../views/ProductListView.vue"),
    meta: {
      animation: true,
    },
  },
  {
    path: "/product/:id",
    name: "product_page",
    component: () => import("../views/ProductPageView.vue"),
    meta: {
      animation: true,
    },
  },
  {
    path: "/terms/:id",
    name: "條款頁面",
    meta: {
      animation: true,
    },
    component: () => import("../views/TermsPageView.vue"),
  },
  {
    path: "/contact",
    name: "聯絡我們",
    meta: {
      animation: true,
    },
    component: () => import("../views/ContactPageView.vue"),
  },
  {
    path: "/event/:id",
    name: "活動銷售頁",
    meta: {
      animation: true,
    },
    component: () => import("../views/EventPageView.vue"),
  },
  {
    path: "/error_page",
    name: "錯誤頁面",
    meta: {
      animation: true,
    },
    component: () => import("../views/ErrorPageView.vue"),
  },
  {
    path: "*",
    redirect: "/error_page",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
